import type { RouteDef } from '../router';
import { ssrBodyFor, browserPath } from '../router';

/**
 * /glossary — SPA side. SSR body: backend/src/util/glossary-body.ts.
 * Same FIXED idempotent-render pattern as agent-landing/price-index
 * (router re-resolves on Auth.onChange/popstate — an unconditional reload
 * here loops; see the 2026-07-07 agent-landing lesson).
 */
const NAV_GUARD_KEY = 'roamzy:glossary-nav';

export const glossaryRoute: RouteDef = {
  path: '/glossary',
  routeType: 'article',
  metaTitle: 'eSIM & Agent-Native Connectivity Glossary | Roamzy',
  metaDesc: 'Plain-language definitions: per-MB metered eSIM, breakage, no-KYC, data-only, eUICC/EID, LPA, agent-native connectivity, MCP, x402, agentic commerce, RLAH.',
  prerenderMarker: '.glossary-route',
  hydrate: () => {
    try { sessionStorage.removeItem(NAV_GUARD_KEY); } catch { /* private mode */ }
    return '';
  },
  render() {
    const ssr = ssrBodyFor('.glossary-route');
    if (ssr !== null) return ssr;
    try {
      if (sessionStorage.getItem(NAV_GUARD_KEY) !== browserPath()) {
        sessionStorage.setItem(NAV_GUARD_KEY, browserPath());
        window.location.assign(browserPath());
        return '';
      }
      sessionStorage.removeItem(NAV_GUARD_KEY);
    } catch {
      window.location.assign(browserPath());
      return '';
    }
    return `<section class="section"><div class="container">`
      + `<p><a href="${browserPath()}">Open the glossary</a></p></div></section>`;
  },
};
